<template>
<div>
  <!-- <h1>Welcome to the Microsatellite Database</h1> -->
  <el-row style="font-family: 'Oxygen', Arial, Helvetica, sans-serif; margin-top: 30px;">
    <el-col :span="18" :offset="3">
      <p style="text-align: justify; font-size: 1.1em;">
        MicroSatellite DataBase (MSDB) is a collection of simple sequence repeats (SSRs), also known as microsatellites. SSRs are short tandem repeats of 1 to 6 base long motifs present in all genomes. Many studies have pointed to the role of SSRs in gene regulation, and have shown that SSRs can act as transcription factor binding sites, enhancer-blockers, insulators etc., making them an interesting class of DNA elements to study. MSDB aims to be the go-to resource for both accessing as well as visualizing SSR-related information.
      </p>
      <div style="display: flex; flex-wrap: wrap; width: 80%; margin-left: 10%">
      <repeat-stat label="Species" stat="40204"></repeat-stat>
      <repeat-stat label="Genomes" stat="46122"></repeat-stat>
      <repeat-stat label="Microsatellites" stat="5.29 billion"></repeat-stat>
      <repeat-stat label="Annotated genomes" stat="32593"></repeat-stat>
      <!-- <repeat-stat label="Analyzed" stat="1234567"></repeat-stat> -->
      </div><br>
    </el-col>
  </el-row>
  <el-row>
      <el-col :offset="3" :span="18">
        <el-row :gutter="40">
          <el-col  :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="margin-top: 20px">
            <div style="text-align: left; font-size: 1.1em">
              <div><strong>Unique features of MSDB:</strong></div>
              <ul style="line-height: 30px;">
                <li><strong>Largest collection</strong> of microsatellites. To our knowledge, MSDB is at least an order of magnitude bigger (in number of repeats and genomes) than other existing databases</li>
                <li>Information displayed as <strong>interactive plots</strong> for easy microsatellite data analysis</li>
                <li>Most plots have options for <strong>multi-species comparison</strong> of data
                <li>Genic <strong>annotation</strong> of repeats to understand their <strong>genomic context</strong></li>
                <li>Table view of all microsatellites from species with <strong>intuitive data filters</strong></li>
                <li><strong>Regularly updated</strong> using data from UCSC, RefSeq and GenBank databases</li>
              </ul>
            </div>
            <p style="font-size: 1.1em;">
              Currently, MSDB has SSR information from 46,122 genomes belonging to various taxa, as outlined below:
            </p>
            <el-table
              :data="speciesTableData"
              border
              size="mini"
              style="width: 80%; font-size: 1em; margin-left: 10%" show-summary sum-text="Total">
              <el-table-column prop="group" label="Kingdom or Group">
              </el-table-column>
              <el-table-column prop="organisms" label="Organisms">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col  :xs="24" :sm="24" :md="24" :lg="12" :xl="12" style="margin-top: 20px">
            <div style="text-align: left"><strong>Quick links to commonly studied species</strong></div>
            <el-table :data="modelOrgTableData" border size="mini" style="width: 100%; font-size: 0.8em; margin-top: 20px; word-break: break-all">
              <el-table-column prop="organismName" label="Organism Name" width="200">
              </el-table-column>
              <el-table-column prop="commonName" label="Common Name" width="150"></el-table-column>
              <el-table-column prop="build" label="Build" width="100"></el-table-column>
              <el-table-column label="Actions" fixed="right" align="center" width="180">
                <template slot-scope="scope">
                  <div>
                  <span style="margin-left: 10px; text-decoration: underline; cursor: pointer; color: #333333" @click="homeAddSpecies(scope.row.msdbid)"><a>View Plots</a></span>
                  <span style="margin-left: 10px; color: #333333"><a :href="`${store.settings.backendBaseURL}${scope.row.msdbid}`" target="_blank">View Table</a></span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-col>
  </el-row>

  <el-row style="margin-top: 30px; margin-right: 0px" align="left">
    <el-col :offset="3" :span="18" style="text-align: left; line-height: 2em" >
      <h2>Citation</h2>
      <div>
        Akshay Kumar Avvaru, Deepak Sharma, Archana Verma, Rakesh K Mishra, Divya Tej Sowpati, MSDB: a comprehensive, annotated database of microsatellites,
        Nucleic Acids Research, Volume 48, Issue D1, 08 January 2020, Pages D155–D159, <a href="https://doi.org/10.1093/nar/gkz886">https://doi.org/10.1093/nar/gkz886</a>
      </div>
    </el-col>
  </el-row>

  <el-row style="margin-top: 80px; margin-right: 0px" align="left">
    <el-col :offset="3" :span="18">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <h2 style="text-align: left">Sources</h2>
          <div class="home-logos">
            <span><img src="../../public/data/ucsc_logo.png"></span>
            <span><img src="../../public/data/ncbi_logo.png"></span>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <h2 style="text-align: left">Developed using</h2>
          <div class="home-logos">
              <span><img src="../../public/data/vue_logo.png"></span>
              <span><img src="../../public/data/django_logo.png"></span>
              <span><img src="../../public/data/mysql_logo.png"></span>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
  <!-- <el-row style="margin-top: 40px">
    <el-col :span="18" :offset="3">
      <home-box-plot></home-box-plot>
    </el-col>
  </el-row> -->
  <el-row :gutter="20" style="color: white; margin-top: 50px; height: 100%; background-color: #324157; padding: 20px; margin-right: 0px">
    <el-col :span="24" style="padding: 3px"> Copyright 2019 © CSIR-Centre for Cellular and Molecular Biology, Uppal Road, Hyderabad - 500007, Telangana, India </el-col>
    <el-col :span="24" style="padding: 3px"> MSDB v3.0.2</el-col>
    <el-col :span="24" style="padding: 3px"> Last updated 24th September 2020 </el-col>
  </el-row>
</div>
</template>

<script>
import { store } from '../scripts/store.js'
import RepeatStat from '../components/RepeatStat.vue'
import HomeBoxPlot from '../components/HomeBoxPlot.vue'
const _ = require('lodash')

export default {
  name: 'Home',
  components: {
    RepeatStat, HomeBoxPlot
  },
  data() {
    return {
      store: store,
      speciesTableData: [
        {
          group: "Bacteria",
          organisms: 25864,
        }, 
        {
          group: "Viruses",
          organisms: 8952
        },
        {
          group: "Archaea",
          organisms: 1554,
        },
        {
          group: "Animals",
          organisms: 2260,
        },
        {
          group: "Plants",
          organisms: 864,
        },
        {
          group: "Protists",
          organisms: 778,
        },
        {
          group: "Fungi",
          organisms: 5804,
        },
        {
          group: "Other Eukaryotes",
          organisms: 46,
        }
      ],
      modelOrgTableData: [
        {
          organismName: "Homo sapiens",
          build: "hg38",
          commonName: "Human",
          msdbid: "MSDBG000001",
        },
        // {
        //   organismName: "Pan troglodytes",
        //   build: "panTro6",
        //   commonName: "Chimpanzee",
        //   msdbid: "MSDBG000002",
        // },
        // {
        //   organismName: "Macaca mulatta",
        //   build: "rheMac8",
        //   commonName: "Rhesus macaque",
        //   msdbid: "MSDBG000003",
        // },
        {
          organismName: "Mus musculus",
          build: "mm10",
          commonName: "Mouse",
          msdbid: "MSDBG000004",
        },
        {
          organismName: "Rattus norvegicus",
          build: "rn6",
          commonName: "Rat",
          msdbid: "MSDBG000005",
        },
        {
          organismName: "Gallus gallus",
          build: "galGal6",
          commonName: "Chicken",
          msdbid: "MSDBG000006",
        },
        {
          organismName: "Xenopus tropicalis",
          build: "xenTro9",
          commonName: "Frog",
          msdbid: "MSDBG000007",
        },
        {
          organismName: "Danio rerio",
          build: "danRer11",
          commonName: "Zebrafish",
          msdbid: "MSDBG000008",
        },
        {
          organismName: "Arabidopsis thaliana",
          build: "TAIR10.1",
          commonName: "Mouse-ear cress",
          msdbid: "MSDBG000832",
        },
        {
          organismName: "Oryza sativa",
          build: "Tetep-1.0_genome",
          commonName: "Rice",
          msdbid: "MSDBG022802",
        },
        {
          organismName: "Drosophila melanogaster",
          build: "dm6",
          commonName: "Fruit fly",
          msdbid: "MSDBG000009",
        },
        {
          organismName: "Caenorhabditis elegans",
          build: "ce11",
          commonName: "Roundworm",
          msdbid: "MSDBG000010",
        },
        {
          organismName: "Saccharomyces cerevisiae",
          build: "sacCer3",
          commonName: "Baker's yeast",
          msdbid: "MSDBG000011",
        },
        {
          organismName: "Escherichia coli",
          build: "ASM522150v1",
          commonName: "NA",
          msdbid: "MSDBG003166",
        },
        
        
      ],
    }
  },
  methods: {
    homeAddSpecies: function (id) {
      const row = _.find(store.species.list, s => {
        return s.MSDBID === id
      })
      store.addSpecies(row)
      store.settings.activeIndex = '2'
    }
  }
}
</script>
<style>
  .home-logos {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
  }

  .home-logos span{
    flex-grow: 1;
    /* margin-right: 20px; */
  }

  .home-logos span img{
    width: 100px;
    height: auto;
  }

</style>
